import React from "react";

export default function InputTextAreaFloat({
  name,
  label,
  type,
  disabled,
  rows,
  resizable,
  marginBottom,
  value,
  onChange,
  hint,
  error,
  touched,
  onKeyDown,
}) {
  return (
    <div className="input-text">
      <div
        className="did-floating-label-content"
        style={{ marginBottom: marginBottom ? marginBottom + "px" : "27px" }}
      >
        <textarea
          name={name}
          rows={rows}
          className="did-floating-input"
          style={{
            height: "auto",
            resize: `${resizable ? "auto" : "none"}`,
            paddingTop: "7px",
          }}
          type={type}
          placeholder=" "
          value={value}
          onChange={onChange}
          disabled={disabled}
          onKeyDown={onKeyDown}
        />
        <label className="did-floating-label">{label}</label>
        <p className="input-hint">{hint}</p>
        {error && touched ? <div className="input-error">{error}</div> : null}
      </div>
    </div>
  );
}
